import useAppStore from "store/app"

const useCheckbox = (fieldName, validate) => {
  const { input_value, error_message } = useAppStore((state) => state.fields[fieldName])

  const updateFieldInputValue = useAppStore((state) => state.updateFieldInputValue)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)

  const handleChange = (e) => {
    const value = e.target.checked

    updateFieldInputValue(fieldName, value)

    const errorMessage = validate(value)

    updateFieldErrorMessage(fieldName, errorMessage)
  }

  return {
    handleChange,
    inputValue: input_value,
    errorMessage: error_message,
  }
}

export default useCheckbox
